// src/components/ui/Logo.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ isFooter = false }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (!isFooter) {
      navigate('/');
    }
  };

  return (
    <div 
      className={`flex items-center ${isFooter ? '' : 'cursor-pointer hover:opacity-80'}`}
      onClick={handleLogoClick}
    >
      {/* Full logo for mobile (hamburger menu) and large desktop */}
      <img 
        src="/images/entelligentsia-logo-cropped.png" 
        alt="Entelligentsia Logo" 
        className="h-8 w-auto block md:hidden xl:block"
      />
      {/* Icon-only for medium screens (desktop nav but constrained width) */}
      <img 
        src="/images/logo-transparent.webp" 
        alt="Entelligentsia" 
        className="hidden md:block xl:hidden h-8 w-8 pr-2.5 object-contain"
      />
    </div>
  );
};

export default Logo;